/**
 * Integer hundredths-of-hours math for client OT/totals (mirrors backend ROUND_HALF_UP 2 dp).
 * See docs/HOURS_DECIMAL.md — never sum IEEE floats for paid hour totals.
 */

/** Parse a duration to integer hundredths (0.01 h), half-up. */
export function hoursToHundredths(value: number | string | null | undefined): number {
  if (value == null || value === "") return 0;
  const n = typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isFinite(n) || n === 0) return 0;
  // Half-up via Math.sign-aware rounding to 2 dp then *100 as int
  const sign = n < 0 ? -1 : 1;
  const abs = Math.abs(n);
  const cents = Math.floor(abs * 100 + 0.5 + Number.EPSILON);
  return sign * cents;
}

export function hundredthsToHours(cents: number): number {
  return cents / 100;
}

/** Format hours for UI tables (always 2 decimal places). */
export function formatHours(value: number | string | null | undefined, empty = "—"): string {
  if (value == null || value === "") return empty;
  const h = hoursToHundredths(value);
  return (h / 100).toFixed(2);
}

export function addHundredths(a: number, b: number): number {
  return a + b;
}

/** Integer 4-dp units (0.0001 h), half-up. Mirrors backend storage quantize. */
export function hoursToTenThousandths(value: number | string | null | undefined): number {
  if (value == null || value === "") return 0;
  const n = typeof value === "number" ? value : Number(String(value).trim());
  if (!Number.isFinite(n) || n === 0) return 0;
  const sign = n < 0 ? -1 : 1;
  const abs = Math.abs(n);
  return sign * Math.floor(abs * 10000 + 0.5 + Number.EPSILON);
}

/** Half-up 4-dp units → 2-dp hundredths (Q2 of a day's 4-dp punch sum). */
export function tenThousandthsToHundredths(units: number): number {
  const sign = units < 0 ? -1 : 1;
  const abs = Math.abs(units);
  return sign * Math.floor(abs / 100 + 0.5);
}
